/**
 * The build this page is running.
 *
 * Injected by Vite from `package.json` (see `vite.config.ts`) rather than restated here, so the
 * number in the About dialog is the number in the tag and cannot drift from it. Outside a Vite build
 * — vitest, or anything importing this module directly — the constant does not exist, and `typeof`
 * on an undeclared identifier is the one form that asks without throwing. It answers `dev`, which is
 * what such a build honestly is.
 */
export const APP_VERSION: string =
  typeof __APP_VERSION__ === 'string' && __APP_VERSION__.length > 0 ? __APP_VERSION__ : 'dev';
